import React from 'react';
import { HiLink } from "react-icons/hi2";
import { IoLogoGithub } from "react-icons/io";

const ProjectCard = ({
  picture,
  picture2x = null,
  github = null,
  website,
  title,
  subtitle,
  description,
  tools = [],
  isImageOnLeft = false,
}) => {
  const orderClass = isImageOnLeft ? "md:flex-row" : "md:flex-row-reverse";

  return (
    <div
      className={`mc-panel flex flex-col overflow-hidden transition-all duration-200 ${orderClass}`}
    >
      {/* Content Column */}
      <div
        data-aos-easing="ease-in-out"
        data-aos="fade-up"
        className="flex flex-col justify-between p-6 md:p-10 md:w-1/2 text-left text-[#aaaaaa] font-mono"
      >
        <div className="space-y-4">
          <div>
            <span className="text-sm font-bold text-[#55ff55] tracking-wider uppercase block mb-1">
              {subtitle}
            </span>
            <h1 className="text-2xl md:text-3xl font-extrabold text-[#ffff55] tracking-tight uppercase select-none">
              {title}
            </h1>
          </div>
          
          <p className="text-md text-[#cccccc] leading-relaxed">
            {description}
          </p>

          {tools && tools.length > 0 && (
            <div className="flex flex-wrap items-center gap-2 py-1">
              {tools.map((tool) => (
                <div key={tool.id} className="mc-slot p-1.5 flex items-center justify-center select-none">
                  <img 
                    alt={tool.alt} 
                    src={tool.img} 
                    className="w-8 h-8 object-contain" 
                  />
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Minecraft Bevel Action Buttons at Bottom */}
        <div className="flex flex-wrap gap-3 mt-6">
          {website && (
            <a 
              href={website}
              target="_blank"
              rel="noopener noreferrer"
              className="mc-btn flex items-center gap-2 !text-[#55ff55]"
            >
              <HiLink size={16} />
              <span>Visit Page</span>
            </a>
          )}
          {github && (
            <a 
              href={github}
              target="_blank"
              rel="noopener noreferrer"
              className="mc-btn flex items-center gap-2"
            >
              <IoLogoGithub size={16} />
              <span>Repository</span>
            </a>
          )}
        </div>
      </div>

      {/* Image Column */}
      <div className="md:w-1/2 overflow-hidden relative min-h-[220px] md:min-h-full bg-black border-t-4 md:border-t-0 md:border-l-4 border-black">
        <img
          data-aos-easing="ease-in-out"
          data-aos="fade-up"
          className="w-full h-full object-cover absolute inset-0 select-none pointer-events-none"
          src={picture}
          srcSet={picture2x ? `${picture} 1x, ${picture2x} 2x` : undefined}
          sizes="(max-width: 768px) 100vw, 50vw"
          alt={title}
        />
      </div>
    </div>
  );
};

export default ProjectCard;


